import { render, staticRenderFns } from "./vehicleManage.vue?vue&type=template&id=0dd067f0&scoped=true"
import script from "./vehicleManage.vue?vue&type=script&lang=js"
export * from "./vehicleManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd067f0",
  null
  
)

export default component.exports